import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { PortalCompatProvider } from '@fluentui/react-portal-compat';

// Sentry
import { initMonitoring } from './monitoring/sentry';

// Redux
import { configureStore } from './redux/store/store';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { StrictMode } from 'react';

// Localization
import './i18n';
import userManager from './auth/userManager';
import { AuthProvider } from './auth/AuthContext';
import { installAuthFetchInterceptor } from './services/httpClient';

// Tema (claro / oscuro / alto contraste de la guía)
import { AppThemeProvider } from './theme/ThemeProvider';

const history = createBrowserHistory();
const store = configureStore(history);

installAuthFetchInterceptor();

// Sin DSN configurado (local) el monitoreo queda apagado. No se inicializa en el callback de silent renew.
if (globalThis.location.pathname !== '/silent_renew') {
  initMonitoring();
}

if (globalThis.location.pathname === '/silent_renew') {
  (async () => {
    try {
      await userManager.signinSilentCallback();
    } catch {
      try {
        if (typeof (userManager as any).clearStaleState === 'function') {
          await (userManager as any).clearStaleState();
        }
        await userManager.removeUser();
      } catch {}
      // Do not trigger interactive redirect from silent renew callback.
      // Let the app decide when to redirect to login.
    }
  })();
} else {
  ReactDOM.render(

    <Provider store={store}>
      <BrowserRouter>
        <StrictMode>
        <AppThemeProvider>
          <PortalCompatProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </PortalCompatProvider>
        </AppThemeProvider>
        </StrictMode>
      </BrowserRouter>
    </Provider>
    ,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
